<template>
  <container class="error-404">
    <introduction
      class="error-404__introduction"
      :title="$t('title')"
    >
      <div class="error-404__content">
        <div>
          <p v-html="$t('message')">
            {{ $t('message') }}
          </p>
          <action-link
            :router-link="{name: link}"
            color="primary"
          >
            {{ $t('tryAgain') }}
          </action-link>
        </div>

        <img
          src="../img/weiche.png"
          alt=""
          class="error-404__image"
        >
      </div>
    </introduction>
  </container>
</template>

<script>
import actionLink from '../components/actionLink.vue'
import container from '../components/container.vue'
import introduction from '../components/introduction.vue'

import api from '../api.js'

export default {
  name: 'VBookingError',

  components: {
    container,
    introduction,
    actionLink
  },

  data () {
    return {
      link: 'booking-personal-information-' + this.$i18n.locale
    }
  },

  created () {
    this.$tracking.eetCheckoutError()
    api.post('checkout/cancel/')
  }
}
</script>

<i18n locale="en">
{
  "title": "Payment failed",
  "message": "Unfortunately a problem occurred and the payment could not be completed. No money was transferred.<br><br>If you pay by credit card, make sure that all information (card number, expiry date and card verification number) was entered correctly.<br><br>Please try again or call our ticket hotline:<br><strong><a href=\"tel:+49403006800\">+49 (0)40 - 300 6 80 - 0</a></strong>",
  "tryAgain": "Try again"
}
</i18n>

<i18n locale="de">
{
  "title": "Zahlung fehlgeschlagen",
  "message": "Leider ist ein Problem aufgetreten und die Bezahlung konnte nicht durchgeführt werden. Ihr Konto wurde nicht belastet.<br><br>Bei einer Zahlung per Kreditkarte, stellen Sie insbesondere sicher, dass alle Angaben (Kreditkartennummer, Gültigkeitsdatum und Prüfnummer) korrekt sind.<br><br>Bitte versuchen Sie es noch einmal oder wenden sich telefonisch an unsere Ticket-Reservierung:<br><strong><a href=\"tel:+49403006800\">040 - 300 6 80 - 0</a></strong>",
  "tryAgain": "Erneut probieren"
}
</i18n>
